<script>
import Multiselect from "vue-multiselect";
import config from "../../config";
import VueGoogleAutocomplete from 'vue-google-autocomplete';
import DropzonePopup from '../../components/widgets/dropzone-popup';
import { error_message, get_user, success_message} from "../../Helper/helper";
import { vendorService, deliveryZoneService, settingService, userService } from "../../services";
import { routes } from "../../config/api_routes";
import {required,email,minValue,maxValue,maxLength,minlength,numeric,helpers,requiredIf} from "vuelidate/lib/validators";
const floating = helpers.regex('floating', /^(?:\d*\.\d{1,2}|\d+)$/)
const phone = helpers.regex('phone', /^([+]{1})?([0-9]*)$/)
/**
 * Add-product component
 */
export default {
  components: { Multiselect,VueGoogleAutocomplete, DropzonePopup},
  data() {
    return {
      file1: null,
      url: null,
      config: config,
      value: null,
      value1: null,
      search: '',
      isLoading: false,
      center: { lat: 0.00, lng: 0.00 },
      markers: [],
      edited: null,
      rescategories: [],
      countries: [],
      states: [],
      cities: [],
      filename: "",
      vendor_currency:'',
      country_count:'',
      state_count:'',
      city_count:'',
      cuisine: [],
      selectedCuisine: [],
      restaurant_image:[],
      typeform: {
        name: "",
        email: "",
        phone: "",
        country: "",
        state: "",
        city: "",
        address: "",
        location_address: "",
        // minimum_order_value: "",
        two_person_price:"",
        delivery_time: "",
        admin_commision: "",
        fssai_licence: "",
        delivery_type_time_slots: 2,
        restaurant_type: 0,
        time_slots: 15,
        currency: "",
        admin_commision_type: "commission_in_INR",
        category_id: 0,
        restaurant_tax: "",
        restaurant_item_layout: 1,
        key: "",
        selectedCuisine: "",
        icon_image: null,
        latitude:"",
        longitude: "",
        name_thai: "",
        address_thai: "",
        is_schedule_order: "",
        chowman_pay_status: "0",
        default_pay_cashback: "0",
		default_pay_cashback_expiry: "0",
        multiple_images:[],
		videos:[],
		walking_terms_and_conditions: "",
		prebook_terms_and_conditions: "",
        // pet_pooja_restaurant_id: ""
      },
	  videos:[],
	  restaurant_video:"",
	  delete_video: routes.deleteVideoUrl,
	  videosvibesthumb : config.videosvibesthumb,
	  upload_type : 'video',
	  pre_booking_fee:0
    };
  },
  validations: {
    typeform: {
      name: {
        required,
      },
      email: {
        required,
        email,
      },
      phone: {
        required,
        phone,
      },
      country: {
        required,
      },
      city: {
        required,
      },
      state: {
        required,
      },
      address: {
        required,
      },
      location_address: {
        required,
      },
      /* minimum_order_value: {
        required,
        floating
      }, */
      delivery_time: {
        required,
        numeric
      },
      admin_commision: {
        required,
        floating
      },
      restaurant_tax: {
        floating
      },
      default_pay_cashback:{
        required:requiredIf(function () {
          return this.typeform.chowman_pay_status == '1';
        }),
        maxValue: maxValue(100),
        minValue: minValue(0),
      },
	  default_pay_cashback_expiry: {
		// required:requiredIf(function () {
		//   return this.typeform.chowman_pay_status == '1';
		// }),
		numeric
	  },
      icon_image: {
        required
      },
      is_schedule_order:{
        required
      },
      time_slots:{
        required
      },
	  pre_booking_fee: {
		  numeric,
	  }
      // pet_pooja_restaurant_id:{
      //   required
      // }
    },
  },
  mounted() {
    this.getVendorCountry();
    this.getAllState();
    this.getAllCity();
    this.getResCategory();
    this.getSetting();
    this.$refs.address.focus();
    this.vendor_id = get_user().vendor_id || 40818;
  },
  methods: {
    onImageDeleted(value) {
      this.restaurant_image = this.restaurant_image.filter(doc => doc.image_name !== value);
    },
    isLetterOrNumber(e) {
        let char = String.fromCharCode(e.keyCode);
        if (/^[A-Za-z0-9]+$/.test(char)) return true;
        else e.preventDefault();
      },

    isNumber(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[0-9]+$/.test(char)) return true;
      else e.preventDefault();
    },
    

    userCheckEmail(e) {
      userService.userCheckEmail({
        email:this.typeform.email,
        table:'User',
        column:'user_id',
        vendor_id:this.vendor_id,
        user_role:'2'
      })
      .then(response => {
        if (response.data.code === 101) {
          error_message(response.data.message);
        }
      });
    },
    asyncFind(query) {
      this.isLoading = true;
      vendorService.getVendorCuisine(query).then((response) => {
        this.cuisine = response.data.result;
        this.isLoading = false;
      });
    },
    clearAll() {
      this.selectedCuisine = [];
    },
    getAddressData: function (addressData, placeResultData, id) {
      this.address = addressData;
      console.log(this.address,placeResultData);
      this.typeform.address = placeResultData.formatted_address;
      this.typeform.latitude = addressData.latitude;
      this.typeform.longitude = addressData.longitude;
      this.$v.typeform.location_address.$model = placeResultData.formatted_address;
      const marker = {
        lat: addressData.latitude,
        lng: addressData.longitude
      };
      this.markers.push({ position: marker });
      this.center = marker;
    },

    getSetting(){
      settingService.getSetting()
      .then(response => {
        const cent = {
          lat: parseFloat(response.data.result.system_latitude),
          lng: parseFloat(response.data.result.system_longitude)
        };
        this.center = cent; 
        this.markers.push({ position: cent });
        this.vendor_currency = response.data.result.currency;
      });
    },

    getVendorCountry(){
      deliveryZoneService.getVendorCountry()
      .then(response => { 
        this.country_count = response.data.result.length;
        this.countries = response.data.result;
        if(this.country_count == 1){
          this.typeform.country = this.countries[0].id;
          this.getVendorState();
        }else{
          this.typeform.country_name = '';
          this.state = '';
          this.city = '';
        }
      });
    },
    getVendorState(){
      deliveryZoneService.getVendorState({
        country_id:this.typeform.country
      })
      .then(response => {
        this.state_count = response.data.result.length;
        this.states = response.data.result;
        if(this.state_count == 1){
          this.typeform.state = this.states[0].id;
          this.getVendorCity();
        }else{
          if(this.typeform.country ==''){
            this.getAllState();
            this.getAllCity();
            this.state = '';
            this.city = '';
          }
          if(this.state ==''){
            this.getVendorCity();
            this.typeform.state = "";
            this.typeform.city = "";
          }
        }
      });
    },
    getVendorCity(){
      deliveryZoneService.getVendorCity({
        state_id:this.typeform.state
      })
      .then(response => {
        this.city_count = response.data.result.length;
        this.cities = response.data.result; 
        if(this.city_count == 1){
          this.typeform.city = this.cities[0].cityid;
        }else{
          if(this.typeform.state ==''){
            this.getAllCity();
            this.city = '';
          }
        } 
      });
    },
    getAllState() {
      deliveryZoneService.getAllState()
        .then((response) => {
        this.states = response.data.result;
        this.state_count = response.data.result.length;
      });
    },
    getAllCity() {
      deliveryZoneService.getAllCity().then((response) => {
        this.cities = response.data.result;
        this.city_count = response.data.result.length;
      });
    },
    getResCategory() {
      vendorService.getResCategory().then((response) => {
        this.rescategories = response.data.result;
      });
    },
    vendorAdd() {
      this.$v.typeform.$touch();
      if (this.$v.typeform.$invalid) {
        return;
      } else {
        const fd = new FormData();
        fd.append("name", this.typeform.name);
        fd.append("email", this.typeform.email);
        fd.append("phone", this.typeform.phone);
        fd.append("country", this.typeform.country);
        fd.append("state", this.typeform.state);
        fd.append("city", this.typeform.city);
        fd.append("address", this.typeform.address);
        fd.append("location_address", this.typeform.location_address);
        fd.append("minimum_order_value", (this.typeform.minimum_order_value || 0));
        fd.append("two_person_price", this.typeform.two_person_price);
        fd.append("delivery_time", this.typeform.delivery_time);
        fd.append("restaurant_type", this.typeform.restaurant_type);
        fd.append("time_slots", this.typeform.time_slots);
        fd.append("currency", this.typeform.currency);
        fd.append("admin_commision_type", this.typeform.admin_commision_type);
        fd.append("admin_commision", this.typeform.admin_commision);
        fd.append("category_id", this.typeform.category_id);
        fd.append("restaurant_tax", this.typeform.restaurant_tax);
        fd.append("chowman_pay_status", this.typeform.chowman_pay_status);
        fd.append("default_pay_cashback", this.typeform.default_pay_cashback);
		fd.append("default_pay_cashback_expiry", this.typeform.default_pay_cashback_expiry);
        fd.append("restaurant_item_layout", this.typeform.restaurant_item_layout);
        fd.append("latitude", this.typeform.latitude);
        fd.append("longitude", this.typeform.longitude);
        fd.append("name_thai", this.typeform.name_thai);
        fd.append("address_thai", this.typeform.address_thai);
        fd.append("fssai_licence", this.typeform.fssai_licence);
        fd.append("delivery_type_time_slots", this.typeform.delivery_type_time_slots);
        // fd.append("multiple_images", this.typeform.multiple_images);

		fd.append("walking_terms_and_conditions", this.typeform.walking_terms_and_conditions);
		fd.append("prebook_terms_and_conditions", this.typeform.prebook_terms_and_conditions);
		fd.append("pre_booking_fee", this.typeform.pre_booking_fee);

		if(this.typeform.multiple_images && Array.isArray(this.typeform.multiple_images)){
			this.typeform.multiple_images.forEach(file => {
				fd.append('multiple_images[]', file);
			});
        }

		if(this.typeform.videos && Array.isArray(this.typeform.videos)){
			this.typeform.videos.forEach((item, index) => {
				fd.append(`multiple_videos[${index}][video]`, item.video);
				fd.append(`multiple_videos[${index}][thumbnail]`, item.thumbnail);
			});
		}
        // fd.append("pet_pooja_restaurant_id", this.typeform.pet_pooja_restaurant_id);
        fd.append("key", this.typeform.key);
        if (!!this.typeform.selectedCuisine) {
          this.typeform.selectedCuisine
            .map((item) => item.cuisine_id)
            .map((item, index) => {
              fd.append("selectedCuisine[" + index + "]", item);
            });
        }
        fd.append("icon_image", this.typeform.icon_image);
        vendorService.addVendor(fd).then((response) => {
          if (response.data.code === 200) {
            success_message(response.data.message);
            this.$router.push({ name: "vendor-list" });
          } else {
            error_message(response.data.message);
          }
        });
      }
    },
    filterInput(e){
      e.target.value = e.target.value.replace(/[^0-9]+/g, '');
    }
  },
};
</script>

<template>
  <div class="row">
    <div class="col-12">
      <form @submit.prevent="vendorAdd">
        <!-- Vendor Info Start -->
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">{{ trans.trans('__JSON__.Vendor Info',{ vendor:  $auth.setting && $auth.setting.restaurant_name })}}</h4>
            <p class="card-title-desc"></p>
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group" v-if="$auth.setting">
                  <label class="required">{{ trans.trans('__JSON__.Vendor Name',{ vendor: $auth.setting && $auth.setting.restaurant_name , lang: $auth.langauges[0] && $auth.langauges[0].name}) }}</label>
                  <input
                    id="name"
                    v-model="$v.typeform.name.$model"
                    type="text"
                    class="form-control"
                    :placeholder="trans.trans('__JSON__.Enter Vendor Name langauge',{vendor: $auth.setting && $auth.setting.restaurant_name , lang: $auth.langauges[0] && $auth.langauges[0].name})"
                    name="name"
                    :class="{ 'is-invalid': $v.typeform.name.$error }"
                  />
                  <div v-if="$v.typeform.name.$error" class="invalid-feedback">
                    <span v-if="!$v.typeform.name.required">{{ trans.trans('__JSON__.Please enter vendor name',{ vendor: $auth.setting && $auth.setting.restaurant_name })}}</span>
                  </div>
                </div>
              </div>

              <div class="col-sm-6 d-none" v-if="$auth.langauges[1].name == 'No Secondary Language'">
              </div>
              <div class="col-sm-6" v-else>
               <div class="form-group" v-if="$auth.setting">
                <label>{{ trans.trans('__JSON__.Vendor Name',{vendor: $auth.setting && $auth.setting.restaurant_name_sec_lang , lang: $auth.langauges[0] && $auth.langauges[1].name })}}</label>
                <input
                  maxlength="100"
                  id="name_thai"
                  name="name_thai"
                  type="text"
                  v-model="typeform.name_thai"
                  :placeholder="trans.trans('__JSON__.Enter Vendor Name langauge',{vendor: $auth.setting && $auth.setting.restaurant_name_sec_lang , lang: $auth.langauges[0] && $auth.langauges[1].name })"
                  class="form-control"
                />
               </div>
              </div>

              <div class="col-sm-6">
                <div class="form-group">
                  <label class="required">{{ trans.get('__JSON__.E-Mail') }}</label>
                  <input
                    id="email"
                    v-model="$v.typeform.email.$model"
                    type="email"
                    name="email"
                    class="form-control"
                    @blur="userCheckEmail"
                    :class="{ 'is-invalid': $v.typeform.email.$error }"
                    placeholder="Enter a valid e-mail"
                  />
                  <div v-if="$v.typeform.email.$error" class="invalid-feedback">
                    <span v-if="!$v.typeform.email.required">{{ trans.get('__JSON__.Please enter email') }}</span>
                    <span v-if="!$v.typeform.email.email">{{ trans.get('__JSON__.This value should be a valid email') }}</span>
                  </div>
                </div>
              </div>

              <div class="col-sm-6">
                <div class="form-group">
                  <label class="required">{{ trans.get('__JSON__.Contact Number') }}</label>
                  <input
                    maxlength="10"
                    minlength="8"
                    id="phone"
                    v-model="$v.typeform.phone.$model"
                    type="tel"
                    name="phone"
                    class="form-control"
                    :class="{ 'is-invalid': $v.typeform.phone.$error }"
                    :placeholder="trans.get('__JSON__.Enter Contact Number')"
                  />
                  <div v-if="$v.typeform.phone.$error" class="invalid-feedback">
                    <span v-if="!$v.typeform.phone.required">{{ trans.get('__JSON__.Please enter contact number') }}</span>
                    <span v-if="!$v.typeform.phone.phone">{{ trans.get('__JSON__.This value should be a valid number') }}</span>
                  </div>
                </div>
              </div>

              <div class="col-sm-6">
                <div class="form-group">
                  <label class="control-label">{{ trans.get('__JSON__.Select Category') }}</label>
                  <select
                    class="custom-select"
                    v-model="typeform.category_id"
                    id="category_id"
                    name="category_id"
                  >
                  <option value="0" selected>{{ trans.get('__JSON__.None') }}</option>
                    <option
                      v-for="res in rescategories"
                      :value="res.category_id"
                      :key="res.category_id"
                    >{{res.category_name}}</option>
                  </select>
                </div>
              </div>

              <div class="col-sm-6">
                <div class="form-group">
                  <label class="control-label">{{trans.get('__JSON__.Select Tags (For Restaurants it will be cuisines)')}}</label>
                   <multiselect
                    v-model="typeform.selectedCuisine"
                    id="ajax"
                    label="cuisine_name"
                    track-by="cuisine_name"
                    :placeholder="trans.get('__JSON__.Search...')"
                    open-direction="bottom"
                    :options="cuisine"
                    :multiple="true"
                    :searchable="true"
                    :loading="isLoading"
                    :internal-search="true"
                    :clear-on-select="false"
                    :close-on-select="false"
                    :options-limit="5"
                    :limit="3"
                    :max-height="600"
                    :show-no-results="false"
                    :hide-selected="true"
                    @search-change="asyncFind"
                  >
                  <template slot="tag" slot-scope="{ option, remove }">
                    <span class="custom__tag">
                      <span>{{ option.cuisine_name }}</span>
                      <span class="custom__remove" @click="remove(option)">❌</span>
                    </span>
                  </template>
                  <template slot="clear" slot-scope="props">
                    <div
                      class="multiselect__clear"
                      v-if="selectedCuisine.length"
                      @mousedown.prevent.stop="clearAll(props.search)"
                    ></div>
                  </template>
                  <span slot="noResult">{{trans.get('__JSON__Oops! No elements found. Consider changing the search query')}}</span>
                </multiselect>
                </div>
              </div>
              <!-- <div class="col-sm-6">
               <div class="form-group">
                <label>{{ trans.trans('__JSON__.Pet Pooja Restaurant ID')}}</label>
                <input
                  maxlength="100"
                  id="pet_pooja_restaurant_id"
                  name="pet_pooja_restaurant_id"
                  type="text"
                  v-model="$v.typeform.pet_pooja_restaurant_id.$model"
                  :placeholder="trans.trans('__JSON__.Enter Pet Pooja Restaurant ID')"
                  class="form-control"
                  :class="{ 'is-invalid': $v.typeform.pet_pooja_restaurant_id.$error }"
                />
                <div v-if="$v.typeform.pet_pooja_restaurant_id.$error" class="invalid-feedback">
                    <span v-if="!$v.typeform.pet_pooja_restaurant_id.required">{{ trans.get('__JSON__.Please enter pet pooja restaurant ID') }}</span>
                  </div>
               </div>
              </div> -->
            </div>
          </div>
        </div>
        <!-- Vendor Info End -->

        <!-- Location Section Start -->
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">{{ trans.get('__JSON__.Location') }}</h4>
            <p class="card-title-desc"></p>

            <div class="row">
              <div class="col-sm-6">
                <div v-if="country_count >1" class="form-group">
                  <label class="control-label required">{{ trans.get('__JSON__.Country') }}</label>
                  <select
                    class="custom-select"
                    v-model="$v.typeform.country.$model"
                    @change="getVendorState"
                    id="country"
                    name="country"
                    :class="{ 'is-invalid': $v.typeform.country.$error }"
                  >
                    <option value selected>{{ trans.get('__JSON__.Select Country') }}</option>
                    <option
                      v-for="con in countries"
                      :value="con.id"
                      :key="con.id"
                    >{{con.country_name}}</option>
                  </select>
                  <div v-if="$v.typeform.country.$error" class="invalid-feedback">
                    <span v-if="!$v.typeform.country.required">{{ trans.get('__JSON__.Please select country') }}</span>
                  </div>
                </div>

                <div v-if="state_count >=1 && city_count > 1" class="form-group">
                  <label class="control-label required">{{ trans.get('__JSON__.City') }}</label>
                  <select
                    class="custom-select"
                    v-model="$v.typeform.city.$model"
                    id="city"
                    name="city"
                    :class="{ 'is-invalid': $v.typeform.city.$error }"
                  >
                    <option value selected>{{ trans.get('__JSON__.Select City') }}</option>
                    <option
                      v-for="cit in cities"
                      :value="cit.cityid"
                      :key="cit.cityid"
                    >{{cit.cityname}}</option>
                  </select>
                  <div v-if="$v.typeform.city.$error" class="invalid-feedback">
                    <span v-if="!$v.typeform.city.required">{{ trans.get('__JSON__.Please select city') }}</span>
                  </div>
                </div>

                <div class="form-group">
                  <label class="control-label required">{{ trans.get('__JSON__.Location based on Latitude/Longitude') }}</label>
                    <!-- id="addres"
                    name="address" -->
                  <vue-google-autocomplete
                    ref="address"
                    type="text"
                    id="location_address"
                    class="form-control"
                    :placeholder="trans.get('__JSON__.Enter location based on Latitude/Longitude')"
                    v-model="$v.typeform.location_address.$model"
                    v-on:placechanged="getAddressData"
                    :class="{'is-invalid':$v.typeform.location_address.$error}"
                    :fields='["formatted_address", "geometry", "name"]'
                    types=""
                    :enable-geolocation="true"
                    >
                  </vue-google-autocomplete>
                  <div v-if="$v.typeform.location_address.$error" class="invalid-feedback">
                    <span v-if="!$v.typeform.location_address.required">{{ trans.get('__JSON__.Please enter address') }}</span>
                  </div>
                </div>

                <div class="form-group">
                  <label class="control-label required">{{ trans.trans('__JSON__.Vendor Full address',{vendor: $auth.setting.restaurant_name} ) }}</label>
                    <!-- id="location_address"
                    name="location_address" -->
                  <input
                    type="text"
                    v-model="$v.typeform.address.$model"
                    class="form-control"
                    :placeholder="trans.trans('__JSON__.Enter Vendor full address',{vendor: $auth.setting.restaurant_name})"
                    :class="{ 'is-invalid': $v.typeform.address.$error }"
                  />
                  <div v-if="$v.typeform.address.$error" class="invalid-feedback">
                    <span
                      v-if="!$v.typeform.address.required"
                    >{{ trans.trans('__JSON__.Please enter Vendor full address',{vendor: $auth.setting.restaurant_name}) }}</span>
                  </div>
                </div>

                <div v-if="$auth.langauges[1].name == 'No Secondary Language'" class="form-group d-none">
                </div>
                <div class="form-group" v-else>
                  <label class="control-label">{{ trans.trans('__JSON__.Vendor Full address Secondary Language (Optional)', {vendor: $auth.setting.restaurant_name_sec_lang , lang: $auth.langauges[1].name }) }}</label>
                  <input
                    id="address_thai"
                    name="address_thai"
                    type="text"
                    class="form-control"
                    v-model="typeform.address_thai"
                    :placeholder="trans.trans('__JSON__.Enter Vendor full address Secondary language', {vendor: $auth.setting.restaurant_name_sec_lang , lang: $auth.langauges[1].name })"
                  />
                </div>
              </div>

              <div class="col-sm-6">
                <div v-if="country_count >=1 && state_count >1" class="form-group">
                  <label class="control-label required">{{ trans.get('__JSON__.State') }}</label>
                  <select
                    class="custom-select"
                    v-model="$v.typeform.state.$model"
                    @change="getVendorCity"
                    id="state"
                    name="state"
                    :class="{ 'is-invalid': $v.typeform.state.$error }"
                  >
                    <option value selected>{{ trans.get('__JSON__.Select State') }}</option>
                    <option v-for="sat in states" :value="sat.id" :key="sat.id">{{sat.state_name}}</option>
                  </select>
                  <div v-if="$v.typeform.state.$error" class="invalid-feedback">
                    <span v-if="!$v.typeform.state.required">{{ trans.get('__JSON__.Please select state')}}</span>
                  </div>
                </div>

                <div class="map1" id="map">
                  <gmap-map :center="center" :zoom="7" style="height: 300px">
                    <gmap-marker
                      v-for="(m, index) in markers"
                      :key="index"
                      :position="m.position"
                      :clickable="true"
                      :draggable="true"
                      @click="center = m.position"
                    ></gmap-marker>
                  </gmap-map>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Location Section End -->

        <!-- Other Info Start -->
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">{{ trans.get('__JSON__.Other Info') }}</h4>
            <p class="card-title-desc"></p>
            <div class="row">
              <!-- <div class="col-sm-6">
                <div class="form-group">
                  <label class="required">
                    {{ trans.get('__JSON__.Minimum Order Amount') }} 
                    ( {{ vendor_currency}} )
                  </label>
                  <input
                    @input="filterInput"
                    id="minimum_order_value"
                    name="minimum_order_value"
                    type="text" 
                    v-model="$v.typeform.minimum_order_value.$model"
                    class="form-control"
                    :placeholder="trans.get('__JSON__.Minimum Order Amount')"
                    :class="{ 'is-invalid':$v.typeform.minimum_order_value.$error }"
                  />
                  <div v-if="$v.typeform.minimum_order_value.$error" class="invalid-feedback">
                    <span v-if="!$v.typeform.minimum_order_value.required">{{ trans.get('__JSON__.Please enter amount') }}</span>
                    <span
                          v-if="!$v.typeform.minimum_order_value.floating"
                        >{{ trans.get('__JSON__.This value should be digits')}}.</span>
                  </div>
                </div>
              </div> -->

              <div class="col-sm-6">
                <div class="form-group">
                  <label>
                    {{ trans.get('__JSON__.Cost for two person') }} ( {{ vendor_currency}} )  ({{ trans.get('__JSON__.Applicable for Restaurants') }})
                  </label>
                  <input
                    @input="filterInput"
                    id="two_person_price"
                    name="two_person_price"
                    type="text"
                    v-model="typeform.two_person_price"
                    class="form-control"
                    :placeholder="trans.get('__JSON__.Cost for two person')"
                    v-on:keypress="isNumber($event)"
                  /> 
                </div>
              </div>

              <div class="col-sm-6">
                <div class="form-group">
                  <label class="required">{{ trans.get('__JSON__.Avg. Processing Time (Min)') }}</label>
                  <input
                    maxlength="6"
                    @input="filterInput"
                    id="delivery_time"
                    name="delivery_time"
                    type="number"
                    v-model="$v.typeform.delivery_time.$model"
                    class="form-control"
                    :placeholder="trans.get('__JSON__.Avg. Processing Time (Min)')"
                    :class="{ 'is-invalid': $v.typeform.delivery_time.$error }"
                  />
                  <div v-if="$v.typeform.delivery_time.$error" class="invalid-feedback">
                    <span v-if="!$v.typeform.delivery_time.required">{{ trans.get('__JSON__.Please enter avg delivery time') }}</span>
                    <span v-if="!$v.typeform.delivery_time.numeric">{{ trans.get('__JSON__.Please enter avg delivery time') }}</span>
                  </div>
                </div>
              </div>

              <div class="col-sm-6">
                <div class="form-group">
                  <label>{{ trans.get('__JSON__.FSSAI licence number') }}</label>
                  <input
                    id="fssai_licence"
                    name="fssai_licence"
                    type="text"
                    class="form-control"
                    v-model="typeform.fssai_licence"
                    :placeholder="trans.get('__JSON__.FSSAI licence number')"
                    v-on:keypress="isLetterOrNumber($event)"
                  />
                </div>
              </div>

              <div class="col-sm-6">
                <div class="form-group">
                  <label class="control-label required">{{ trans.get('__JSON__.Admin Commission Type') }}</label>
                  <select
                    class="custom-select"
                    v-model="typeform.admin_commision_type"
                    id="admin_commision_type"
                    name="admin_commision_t ype"
                  >
                    <option value="">{{ trans.get('__JSON__.Select Admin Commission') }}</option>
                    <option value="commission_in_INR">{{ trans.get('__JSON__.Fixed') }} ( {{ vendor_currency}} )</option>
                    <option value="commission_in_fixed">{{ trans.get('__JSON__.Percentage') }} (%)</option>
                  </select>
                </div>
              </div>

              <div class="col-sm-6">
                <div class="form-group">
                  <label class="required">{{ trans.get('__JSON__.Admin Commission Value') }}</label>
                  <input
                    id="admin_commision"
                    name="admin_commision"
                    type="text"
                    maxlength="100"
                    @input="filterInput"
                    v-model="$v.typeform.admin_commision.$model"
                    class="form-control"
                    :placeholder="trans.get('__JSON__.Admin Commission Value')"
                    :class="{ 'is-invalid': $v.typeform.admin_commision.$error }"
                  />
                  <div v-if="$v.typeform.admin_commision.$error" class="invalid-feedback">
                    <span
                      v-if="!$v.typeform.admin_commision.required"
                    >{{ trans.get('__JSON__.Please enter admin commission') }}</span>
                    <span
                          v-if="!$v.typeform.admin_commision.floating"
                        >{{ trans.get('__JSON__.This value should be digits')}}.</span>
                  </div>
                </div>
              </div>

              <div class="col-sm-6">
                <div class="form-group">
                  <label class="control-label">{{ trans.trans('__JSON__.Vendor Type',{ vendor: $auth.setting.restaurant_name }) }}</label>
                  <select
                    class="custom-select"
                    v-model="typeform.restaurant_type"
                    id="restaurant_type"
                    name="restaurant_type"
                  >
                    <option value="" >{{ trans.get('__JSON__.Select Vendor Type',{ vendor: $auth.setting.restaurant_name }) }}</option>
                    <option v-bind:value="0" selected>{{ trans.get('__JSON__.All') }}</option>
                    <option v-bind:value="1">{{ trans.get('__JSON__.Pure Veg') }}</option>
                    <option v-bind:value="2">{{ trans.get('__JSON__.Non Veg') }}</option>
                    <option v-bind:value="3">{{ trans.get('__JSON__.Not Applicable') }}</option>
                  </select>
                </div>
              </div>

              <div class="col-sm-6">
                <div class="form-group">
                  <label class="control-label">{{ trans.get('__JSON__.Time Slot') }}</label>
                  <select
                    name="time_slots"
                    class="custom-select"
                    id="time_slots"
                    v-model="$v.typeform.time_slots.$model"
                    :class="{ 'is-invalid': $v.typeform.time_slots.$error }"
                  >
                    <option value="">{{ trans.get('__JSON__.Select Time Slot') }}</option>
                    <option value="15" selected>15 {{ trans.get('__JSON__.Mins') }}</option>
                    <option value="30">30 {{ trans.get('__JSON__.Mins') }}</option>
                    <option value="45">45 {{ trans.get('__JSON__.Mins') }}</option>
                    <option value="60">1 {{ trans.get('__JSON__.Hour') }}</option>
                    <option value="120">2 {{ trans.get('__JSON__.Hours') }}</option>
                    <option value="180">3 {{ trans.get('__JSON__.Hours') }}</option>
                    <option value="240">4 {{ trans.get('__JSON__.Hours') }}</option>
                    <option value="480">8 {{ trans.get('__JSON__.Hours') }}</option>
                    <option value="540">9 {{ trans.get('__JSON__.Hours') }}</option>
                  </select>
                  <div  v-if="$v.typeform.time_slots.$error" class="invalid-feedback">
                    <span v-if="!$v.typeform.time_slots.required">Please select time slot.</span>
                  </div>
                </div>
              </div>

              <div class="col-sm-6" v-if="$auth.setting.is_pickup_enable == true">
                <div class="form-group">
                  <label class="control-label">{{ trans.get('__JSON__.Delivery Type & Time Slots') }}</label>
                  <select
                    class="custom-select"
                    v-model="typeform.delivery_type_time_slots"
                    id="delivery_type_time_slots"
                    name="delivery_type_time_slots"
                  >
                    <option value="">{{ trans.get('__JSON__.Select Delivery Type') }}</option>
                    <option v-bind:value="0">{{ trans.get('__JSON__.Pickup') }}</option>
                    <option v-bind:value="1">{{ trans.get('__JSON__.Delivery') }}</option>
                    <option v-bind:value="2" selected>{{ trans.get('__JSON__.Both') }}</option>
                  </select>
                </div>
              </div>

              <div class="col-sm-6">
                <div class="form-group">
                  <label class="control-label">{{ trans.get('__JSON__.GST',{gst: $auth.getTaxName()})}} (%)</label>
                  <input
                    id="restaurant_tax"
                    name="restaurant_tax"
                    type="text"
                    class="form-control"
                    v-model="$v.typeform.restaurant_tax.model"
                    :placeholder="trans.get('__JSON__.Vendor GST',{gst: $auth.getTaxName()})"
                    v-on:keypress="isNumber($event)"
                  />
                </div>
              </div>

              <div class="col-sm-6">
                <div class="form-group">
                  <label class="control-label">{{ trans.trans('__JSON__.Vendor Details Page Layout',{ vendor: $auth.setting.restaurant_name }) }}</label>
                  <select
                    class="custom-select"
                    v-model="typeform.restaurant_item_layout"
                    id="restaurant_item_layout"
                    name="restaurant_item_layout"
                  >
                    <option value="">{{ trans.get('__JSON__.Select Page Layout') }}</option>
                    <option v-bind:value="1" selected>{{ trans.get('__JSON__.Layout') }} 1</option>
                    <option v-bind:value="2">{{ trans.get('__JSON__.Layout') }} 2</option>
                    <option v-bind:value="3">{{ trans.get('__JSON__.Layout') }} 3</option>
                  </select>
                </div>
              </div>
              
              <div class="col-sm-6">
                <div class="form-group">
                  <label class="control-label required">{{ trans.trans('__JSON__.Scheduling Order') }}</label>
                  <select
                    class="custom-select"
                    v-model="typeform.is_schedule_order"
                    id="is_schedule_order"
                    name="is_schedule_order"
                  >
                    <option value="">{{ trans.get('__JSON__.Select One') }}</option>
                    <option v-bind:value="'0'">{{trans.get("__JSON__.Off")}}</option>
                    <option v-bind:value="'1'">{{trans.get("__JSON__.On")}}</option>
                  </select>
                </div>
                <div v-if="$v.typeform.is_schedule_order.$error" class="invalid-feedback cuisine-img">
                  <span
                    v-if="!$v.typeform.is_schedule_order.required"
                  >{{ trans.get('__JSON__.required',{attribute: trans.trans('__JSON__.Scheduling Order')}) }}</span>
                </div>
              </div>

              <div class="col-sm-6">
				<div class="form-group">
					<label class="control-label">{{
					trans.trans("__JSON__.Dine In Pre-Booking Fee Per Pax")
					}}</label>
					<input
					id="pre-booking-fee"
					name="pre-booking-fee"
					type="text"
					class="form-control"
					:placeholder="trans.get('__JSON__.Dine In Pre-Booking Fee Per Pax')"
					v-model="$v.typeform.pre_booking_fee.$model"
					v-on:keypress="isNumber($event)"
					/>
				</div>
				<div
					v-if="$v.typeform.pre_booking_fee.$error"
					class="invalid-feedback cuisine-img"
				>
					<span v-if="!$v.typeform.pre_booking_fee.numeric">{{
					trans.trans("__JSON__.required", {
						attribute: trans.trans("__JSON__.Dine In Pre-Booking Fee Per Pax"),
					})
					}}</span>
				</div>
				</div>

              <div class="col-sm-6">
                <div class="form-group">
                  <label class="control-label">{{ trans.trans('__JSON__.Chowman Pay') }}</label><br>
                  <label class="switch">
                    <input
                      type="checkbox"
                      id="chowman_pay_status"
                      v-model="typeform.chowman_pay_status"
                      class="switch-on"
                      true-value="1"
                      false-value="0"
                    />
                    <div class="slider round">
                      <span class="on">{{ trans.get('__JSON__.Yes') }}</span>
                      <span class="off">{{ trans.get('__JSON__.No') }}</span>
                    </div>
                  </label>
                </div>
              </div>

              <div class="col-sm-6" v-if="typeform.chowman_pay_status == '1'">
                  <div class="form-group">
                    <label class="control-label">{{ trans.get('__JSON__.Default Pay Cashback')}} (%)</label>
                    <input
                      id="default_pay_cashback"
                      name="default_pay_cashback"
                      v-model="$v.typeform.default_pay_cashback.$model"
                      type="text"
                      class="form-control"
                      :placeholder="trans.get('__JSON__.Default Pay Cashback')"
                    />
                  </div>
                  <div v-if="$v.typeform.default_pay_cashback.$error" class="invalid-feedback cuisine-img">
                      <span v-if="!$v.typeform.default_pay_cashback.required" >
                        {{ trans.get('__JSON__.required',{attribute: trans.trans('__JSON__.Default Pay Cashback')}) }}
                      </span>
                      <span v-else-if="!$v.typeform.default_pay_cashback.maxValue" >
                        {{ trans.get('__JSON__.maxValue',{attribute: trans.trans('__JSON__.Default Pay Cashback')}) }}
                      </span>
                      <span v-else-if="!$v.typeform.default_pay_cashback.minValue" >
                              {{ trans.get('__JSON__.minValue',{attribute: trans.trans('__JSON__.Default Pay Cashback')}) }}
                       </span>
                  </div>
              </div>

			  <div class="col-sm-6" v-if="typeform.chowman_pay_status == '1'">
                  <div class="form-group">
                    <label class="control-label">{{ trans.get('__JSON__.Default Cashback Expiry Days')}}</label>
                    <input
                      id="default_pay_cashback_expiry"
                      name="default_pay_cashback_expiry"
                      v-model="$v.typeform.default_pay_cashback_expiry.$model"
                      type="text"
                      class="form-control"
                      :placeholder="trans.get('__JSON__.Default Cashback Expiry Days')"
                    />
                  </div>
                  <div v-if="$v.typeform.default_pay_cashback_expiry.$error" class="invalid-feedback cuisine-img">
                      <!-- <span v-if="!$v.typeform.default_pay_cashback_expiry.required" >
                        {{ trans.get('__JSON__.required',{attribute: trans.trans('__JSON__.Default Cashback Expiry Days')}) }}
                      </span> -->
                      <span v-if="!$v.typeform.default_pay_cashback_expiry.maxValue" >
                        {{ trans.get('__JSON__.numeric',{attribute: trans.trans('__JSON__.Default Cashback Expiry Days')}) }}
                      </span>
                  </div>
              </div>

			  <div class="col-md-12">
					<div class="row">
						<div class="col-md-6">
							<label>{{ trans.trans('__JSON__.Walking table booking T&C') }}</label>
							<textarea
								v-model="typeform.walking_terms_and_conditions"
								id="walking_terms_and_conditions"
								name="walking_terms_and_conditions"
								type="text"
								:placeholder="trans.trans('__JSON__.Walking table booking T&C')"
								class="form-control"
								rows="5"
							></textarea>
						</div>
		
						<div class="col-md-6">
							<label>{{ trans.trans('__JSON__.Prebook table booking T&C') }}</label>
							<textarea
								v-model="typeform.prebook_terms_and_conditions"
								id="prebook_terms_and_conditions"
								name="prebook_terms_and_conditions"
								type="text"
								:placeholder="trans.trans('__JSON__.Prebook table booking T&C')"
								class="form-control"
								rows="5"
							></textarea>
						</div>
					</div>
				</div>
            </div>
          </div>
        </div>
        <!-- Other Info End -->

        <!-- Vendor Image Start -->
        <div class="card">
          <div class="card-body">
            <h4 class="card-title required">{{ trans.trans('__JSON__.Vendor Image',{ vendor: $auth.setting.restaurant_name }) }}</h4>
            <p class="card-title-desc"></p>
            <div class="row">
              <div class="col-sm-3">
                <dropzone-popup
                  v-model="typeform.icon_image"
                  type="file"
                  id="icon_image"
                  name="icon_image"
                  acceptedFiles=".jpeg,.jpg,.png"
                  :class="{ 'is-invalid': $v.typeform.icon_image.$error }"
                />
                <div v-if="$v.typeform.icon_image.$error" class="invalid-feedback cuisine-img">
                  <span
                    v-if="!$v.typeform.icon_image.required"
                  >{{ trans.get('__JSON__.Please select image') }}</span>
                </div>
              </div> 
            </div>

            <h4 class="card-title mt-4">{{
                  trans.trans("__JSON__.Photos", {
                    vendor: $auth.setting.restaurant_name,
                  })
                }}</h4>

            <div class="row">
                <div class="col-sm-12 imgUp">
                  
                  <dropzone-popup
                    multiple
                    v-model="typeform.multiple_images"
                    id="multiple_images"
                    name="multiple_images"
                    acceptedFiles=".jpeg,.jpg,.png"
                    :editable-images="restaurant_image.map(o => o.filename)"
                    @image-deleted="this.onImageDeleted"
					:maxFiles="10"
                  />
                </div>
              </div>

			  <div class="row">
				<div class="col-md-12">
					<h4 class="card-title mt-5">{{ trans.trans("__JSON__.Vibes") }}</h4>
					<div class="row">
						<div class="col-sm-12 imgUp">
							<dropzone-popup
								multiple
								v-model="typeform.videos"
								id="multiple_videos"
								name="multiple_videos"
								:editable-videos="videos.map(o => o)"
								:media-path="restaurant_video"
								:thumb-path="videosvibesthumb"
                    			:delete-path="delete_video"
								:custom-params="{ 'type': 'multiple' }"
								acceptedFiles="video/*"
								:upload-type="this.upload_type"
							/>
						</div>
					</div>
				</div>
			  </div>

            <div class="row">
              <div class="col-sm-6">
                <button type="submit" class="btn btn-primary mr-1 mt-3">{{ trans.trans('__JSON__.Add Vendor',{ vendor: $auth.setting.restaurant_name }) }}</button>
                <b-button @click="$router.back()" type="button" variant="secondary" class="mt-3">{{ trans.get('__JSON__.Cancel') }}</b-button>
              </div>
            </div>
          </div>
        </div>

        <!-- Vendor Image End -->
      </form>
    </div>
  </div>
  <!-- end row -->
</template>
